import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as SalesRecommendationActions from "./actions";
import type { ISalesRecommendationState } from "./types";

const initialState: ISalesRecommendationState = {
  data: null!,
  hasError: false,
  isFetching: false
};

export default function salesRecommendationReducer(
  state: ISalesRecommendationState = initialState,
  action: ActionType<typeof SalesRecommendationActions>
): ISalesRecommendationState {
  switch (action.type) {
    case getType(SalesRecommendationActions.fetchSalesRecommendationStart): {
      return {
        ...state,
        isFetching: true
      };
    }

    case getType(SalesRecommendationActions.fetchSalesRecommendationFail): {
      return {
        ...state,
        hasError: true,
        isFetching: false
      };
    }

    case getType(SalesRecommendationActions.fetchSalesRecommendationSuccess): {
      return {
        ...state,
        data: action.payload,
        isFetching: false
      };
    }

    default:
      return state;
  }
}
